import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pagination } from "../../../Utils";
import {
  ErrorToast,
  TextAreaRefund,
  SuccessToast,
} from "../../../Utils/SweetAlert";
import {
  GetCustomerWalletRequestCardPaginate,
  ApproveRefundCustomerWalletRequest,
} from "../../../Services/Api/customer";
import format from "date-fns/format";
import { Helmet } from "react-helmet-async";
import { StartCase } from "react-lodash";
import _ from "lodash";
import { showCustName } from "../../../Utils/CommanFunctions";

const CardWalletRequest = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [customerWalletRequest, setCustomerWalletRequest] = useState([]);
  const [customerWalletamount, setCustomerWalletAmount] = useState([]);

  const getCustomerList = async (limitO = "", pageO = "") => {
    setIsLoading(true);
    await GetCustomerWalletRequestCardPaginate({ limit: limitO, page: pageO })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.totalRecords > 0) {
          setCustomerWalletRequest(res?.data?.data?.transactions);
          setTotalRecords(res?.data?.data?.totalRecords);
        } else {
          setCustomerWalletRequest([]);
          setTotalRecords(0);
          // ErrorToast("No Results.");
        }
      })
      .catch((err) => {
        setCustomerWalletRequest([]);
        setTotalRecords(0);
        setIsLoading(false);
        // if (typeof err.response.data.message !== "undefined") {
        //   ErrorToast(err.response.data.message || "Server Error!!");
        // } else {
        //   ErrorToast(err?.message || "Server Error!!");
        // }
      });
  };
  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
  };
  const handleLimitChange = async (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getCustomerList(limit, page);
  }, [limit, page]);

  const approveRefund = (item, mode = 1, amount) => {
    var postObj = { payment_id: item._id };
    if (mode == 2) {
      TextAreaRefund({ denyButtonText: "Cancel", amount }).then(
        async (result) => {
          if (result.isConfirmed) {
            postObj.refund_reason = result?.value?.reason;
            postObj.amount = parseFloat(result?.value?.amount);
            await makeApproveReject(postObj);
          }
        }
      );
    }
  };
  async function makeApproveReject(postObj) {
    await ApproveRefundCustomerWalletRequest(postObj)
      .then((res) => {
        SuccessToast(res?.data?.message || "Status Updated");
        getCustomerList(limit, page);
      })
      .catch((err) => {
        // if (typeof err.response.data.message !== "undefined") {
        //   ErrorToast(err.response.data.message || "Server Error!!");
        // } else {
        //   ErrorToast(err?.message || "Server Error!!");
        // }
      });
  }
  return (
    <>
      <Helmet>
        <title>CPay | Admin Card Deposit</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Card Deposit</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Card Deposit</li>
                </ul>
              </div>
            </div>
          </div>
          {/* common component import here */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-stripped table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Status</th>
                          <th>User</th>
                          <th>Date</th>
                          <th>Merchant Order No.</th>
                          <th>PayBy Order No.</th>
                          <th>Amount</th>
                          <th>Details</th>
                          <th>Refund Status</th>
                          <th>Refund Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading && (
                          <>
                            {customerWalletRequest.map((customer, index) => (
                              <tr key={index}>
                                <td>{limit * page + (index + 1)}</td>
                                <td>
                                  <StartCase
                                    string={_.toLower(
                                      _.replace(customer?.paybyStatus, "_", " ")
                                    )}
                                  />
                                  {customer?.refund_status == 0 &&
                                    (customer?.paybyStatus == "PAID_SUCCESS" ||
                                      customer?.paybyStatus == "SETTLED") && (
                                      <>
                                        {" "}
                                        |{" "}
                                        <Link
                                          to="#"
                                          className="btn btn-sm btn-white text-success me-2"
                                          data-toggle="modal"
                                          onClick={() =>
                                            approveRefund(
                                              customer,
                                              2,
                                              customer.amount
                                            )
                                          }
                                        >
                                          Refund
                                        </Link>{" "}
                                      </>
                                    )}
                                </td>
                                <td>
                                  {
                                    (customer?.user?.name && customer?.user?.company_name)
                                    ?
                                      showCustName(customer?.user?.name, customer?.user?.company_name)
                                    :
                                      (customer?.user?.name)
                                      ?
                                        customer?.user?.name
                                      :
                                        ""
                                  }
                                  <br />
                                  {customer?.user?.mobile || "-"}
                                  <br />
                                </td>
                                <td>
                                  <span>
                                    {format(
                                      new Date(customer?.createdAt),
                                      "dd MMMM, yyyy"
                                    )}
                                  </span>
                                </td>
                                <td>{customer?.merchantOrderNo || "-"}</td>
                                <td>{customer?.orderNo || "-"}</td>
                                <td>
                                  <span className="currency-type-text">
                                    {customer?.currency}{" "}
                                  </span>
                                  {customer?.amount || "-"}
                                </td>
                                <td>{customer?.details || "-"}</td>
                                <td>
                                  {customer?.refund_status === 1 && (
                                    <span className="badge badge-pill bg-primary-light">
                                      Initialised
                                    </span>
                                  )}
                                  {customer?.refund_status === 2 && (
                                    <span className="badge badge-pill bg-success-light">
                                      Refunded
                                    </span>
                                  )}
                                  {customer?.refund_status === 0 && (
                                    <span className="badge badge-pill bg-warning-light">
                                      Not initialised
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <span className="currency-type-text">
                                    {customer?.currency}{" "}
                                  </span>
                                  {customer?.refunded_amount || "0"}
                                </td>
                              </tr>
                            ))}
                            {customerWalletRequest.length === 0 && (
                              <tr>
                                <td colSpan={10}>No Records Found.</td>
                              </tr>
                            )}
                          </>
                        )}
                        <Pagination
                          totalItem={totalRecords}
                          itemsPerPage={limit}
                          page={page}
                          handleChangePage={handlePageChange}
                          handleChangeRowsPerPage={handleLimitChange}
                          colSpan={10}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className=" container-fluid absolute mb-4">
              <footer className="text-center text-lg-start">
                <div className="text-center">Powered by Alsaffron System.</div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardWalletRequest;
